export const environment = {
  production: false,
  stage: 'dev',
  domain: 'redcornerai.com',
  apiUrl: 'https://devapi.redcornerai.com',
  cognitoUserPoolId: 'us-east-2_1tkz9j0BZ',
  cognitoClientId: '2nbq91nlbeprcan7pmqn2jispo',
  cognitoDomain: 'redcornerai-dev-tenant.auth.us-east-2.amazoncognito.com',
  googleClientId: 'PLACEHOLDER_GOOGLE_CLIENT_ID',
  callbackUrl: 'https://dev.redcornerai.com/auth/callback',
  logoutUrl: 'https://dev.redcornerai.com/auth/login',
  // Cloudflare Turnstile site key (public). Same key used by the chat widget.
  turnstileSiteKey: '0x4AAAAAAEYrc2VSJNoQxe47',
  // Base URL of the AI-agent conversation history/stats HTTP API, created by
  // ai-agent-framework/infra/10_conversation_pipeline.py. Set this to the
  // endpoint printed by that script (https://{api_id}.execute-api.us-east-2
  // .amazonaws.com). Empty disables the Reception History/stats features.
  conversationApiUrl: 'https://6excsafqmb.execute-api.us-east-2.amazonaws.com',
  // WebSocket endpoint of the AI-agent "connector" API (redcornerai-dev-agent-ws,
  // managed by ai-agent-framework/infra/05_connector_lambda.py). Used by the
  // authenticated AI Managers panel to open an INTERNAL management conversation
  // with the office_manager / human_resource_manager agents via the connector's
  // internal $connect path. NOTE: this is the AGENT connector API, NOT the public
  // chat.html chat-ws API — only the agent connector handles the internal auth path.
  connectorWsUrl: 'wss://datpdsvdab.execute-api.us-east-2.amazonaws.com/dev',
};
